import IcDashboard from '../../assets/icons/dashboard.svg';
import IcUser from '../../assets/icons/user.svg';
import IcProduct from '../../assets/icons/product.svg';
import IcOrder from '../../assets/icons/order.svg';
import IcOrderService from '../../assets/icons/order-service.svg';
import IcReport from '../../assets/icons/report.svg';
import IcSetting from '../../assets/icons/settings.svg';
import IcMerchant from '../../assets/icons/shop.svg';
import IcSlider from '../../assets/icons/sliders.svg';
import IcChats from '../../assets/icons/chats.svg';
import IcPromo from '../../assets/icons/promo.svg';
import ICWallet from '../../assets/icons/wallet.png';
import GridViewOutlinedIcon from '@mui/icons-material/GridViewOutlined';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import LocalMallOutlinedIcon from '@mui/icons-material/LocalMallOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import QuestionAnswerOutlinedIcon from '@mui/icons-material/QuestionAnswerOutlined';
import DiscountOutlinedIcon from '@mui/icons-material/DiscountOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';

export interface MenuTypes {
  id: string;
  type: string;
  path: string;
  route?: string;
  permission: string;
  text: string;
  children?: Children[];
  icon?: any;
  disableActive?: boolean;
  target?: string;
}

interface Children {
  id: string;
  type: string;
  path: string;
  route?: string;
  permission: string;
  text: string;
  children?: any;
  icon?: any;
  margin: string;
  target?: string;
}

const features: MenuTypes[] = [
  {
    id: 'dashboard',
    text: 'Beranda',
    path: '/',
    route: '/',
    type: 'item',
    permission: 'dashboard@isView',
    icon: GridViewOutlinedIcon,
    disableActive: true,
  },
  {
    id: 'adminrevenue',
    text: 'Pendapatan',
    path: '/withdraws',
    route: '/withdraws',
    type: 'item',
    permission: 'withdraws@isView',
    icon: ICWallet,
    disableActive: true,
  },
  {
    id: 'reseller',
    text: 'Pelanggan',
    path: '#',
    route: '/customers',
    type: 'collapse',
    permission: 'dashboard@isView',
    icon: GroupOutlinedIcon,
    children: [
      {
        id: 'customers',
        text: 'Daftar Pelanggan',
        path: '/customers',
        route: '/customers',
        type: 'item',
        permission: 'dashboard@isView',
        margin: '0 0 0 20px',
      },
      {
        id: 'resellerlist',
        text: 'Daftar Reseller',
        path: '/reseller',
        route: '/reseller',
        type: 'item',
        permission: 'addReseller@isView',
        margin: '0 0 0 20px',
      },
    ],
  },
  // {
  //   id: "home",
  //   text: "Home",
  //   path: "/home",
  //   type: "item",
  //   permission: "home@isView",
  //   icon: IcDashboard,
  // },
  // {
  //   id: "whatsapp",
  //   text: "Whatsapp",
  //   path: "/whatsapp",
  //   type: "item",
  //   permission: "whatsapp@isView",
  //   icon: IcDashboard,
  // },
  {
    id: 'product',
    text: 'Produk',
    path: '#',
    route: '/products',
    type: 'collapse',
    permission: 'products@isView',
    icon: Inventory2OutlinedIcon,
    children: [
      {
        id: 'listproducts',
        text: 'Daftar Produk',
        path: '/products',
        route: '/products',
        type: 'item',
        permission: 'listproduct@isView',
        // icon: IcDashboard,
        margin: '0 0 0 20px',
      },
      {
        id: 'productvariants',
        text: 'Daftar Atribut',
        path: '/variants',
        route: '/variants',
        type: 'item',
        permission: 'productvariants@isView',
        // icon: IcDashboard,
        margin: '0 0 0 20px',
      },
      {
        id: 'category',
        text: 'Kategori',
        path: '/categories',
        route: '/categories',
        type: 'item',
        permission: 'category@isView',
        // icon: IcDashboard,
        margin: '0 0 0 20px',
      },
      {
        id: 'brands',
        text: 'Merek',
        path: '/brands',
        route: '/brands',
        type: 'item',
        permission: 'brand@is_view',
        margin: '0 0 0 20px',
      },
      {
        id: 'provider',
        text: 'Provider',
        path: '/provider',
        route: '/provider',
        type: 'item',
        permission: 'provider@is_view',
        margin: '0 0 0 20px',
      },
      {
        id: 'aistudio',
        text: 'AI Product Studio',
        path: 'https://g.co/gemini/share/f380bef3a1ca',
        route: 'https://g.co/gemini/share/f380bef3a1ca',
        type: 'item',
        permission: 'aistudio@isView',
        target: '_blank',
        margin: '0 0 0 20px',
      },
    ],
  },
  {
    id: 'order',
    text: 'Penjualan Retail',
    path: '#',
    route: '/orders',
    type: 'collapse',
    permission: 'order@isView',
    icon: LocalMallOutlinedIcon,
    children: [
      {
        id: 'pendingorder',
        text: 'Pending',
        path: '/orders/pending',
        route: '/orders/pending',
        type: 'item',
        permission: 'order@isView',
        margin: '0 0 0 20px',
      },
      {
        id: 'neworder',
        text: 'Baru',
        path: '/orders/new',
        route: '/orders/new',
        type: 'item',
        permission: 'order@isView',
        margin: '0 0 0 20px',
      },
      {
        id: 'processorder',
        text: 'Proses',
        path: '/orders/process',
        route: '/orders/process',
        type: 'item',
        permission: 'order@isView',
        margin: '0 0 0 20px',
      },
      {
        id: 'readypickuporder',
        text: 'Siap diambil',
        path: '/orders/ready',
        route: '/orders/ready',
        type: 'item',
        permission: 'order@isView',
        margin: '0 0 0 20px',
      },
      {
        id: 'deliveryorder',
        text: 'Dikirim',
        path: '/orders/delivery',
        route: '/orders/delivery',
        type: 'item',
        permission: 'order@isView',
        margin: '0 0 0 20px',
      },
      {
        id: 'complainedorder',
        text: 'Komplain',
        path: '/orders/complained',
        route: '/orders/complained',
        type: 'item',
        permission: 'order@isView',
        margin: '0 0 0 20px',
      },
      {
        id: 'waitingconfirmationorder',
        text: 'Menunggu Konfirmasi',
        path: '/orders/waiting',
        route: '/orders/waiting',
        type: 'item',
        permission: 'order@isView',
        margin: '0 0 0 20px',
      },
      {
        id: 'completedorder',
        text: 'Selesai',
        path: '/orders/completed',
        route: '/orders/completed',
        type: 'item',
        permission: 'order@isView',
        margin: '0 0 0 20px',
      },
      {
        id: 'canceledorder',
        text: 'Batal',
        path: '/orders/canceled',
        route: '/orders/canceled',
        type: 'item',
        permission: 'order@isView',
        margin: '0 0 0 20px',
      },
    ],
  },
  {
    id: 'order-service',
    text: 'Penjualan Jasa',
    path: '#',
    route: '/order-service',
    type: 'collapse',
    permission: 'orderService@isView',
    icon: IcOrderService,
    children: [
      {
        id: 'pendingorder',
        text: 'Pending',
        path: '/order-service/pending',
        route: '/order-service/pending',
        type: 'item',
        permission: 'order@isView',
        margin: '0 0 0 20px',
      },
      {
        id: 'neworder',
        text: 'Baru',
        path: '/order-service/new',
        route: '/order-service/new',
        type: 'item',
        permission: 'orderService@isView',
        margin: '0 0 0 20px',
      },
      {
        id: 'processorder',
        text: 'Proses',
        path: '/order-service/process',
        route: '/order-service/process',
        type: 'item',
        permission: 'orderService@isView',
        margin: '0 0 0 20px',
      },
      {
        id: 'completedorder',
        text: 'Selesai',
        path: '/order-service/completed',
        route: '/order-service/completed',
        type: 'item',
        permission: 'orderService@isView',
        margin: '0 0 0 20px',
      },
      {
        id: 'canceledorder',
        text: 'Batal',
        path: '/order-service/canceled',
        route: '/order-service/canceled',
        type: 'item',
        permission: 'orderService@isView',
        margin: '0 0 0 20px',
      },
    ],
  },
  {
    id: 'finance',
    text: 'Keuangan',
    path: '#',
    route: '/finance',
    type: 'collapse',
    permission: 'finance@isView',
    icon: AssessmentOutlinedIcon,
    children: [
      {
        id: 'bank',
        text: 'Bank',
        path: '/finance/bank',
        route: '/finance/bank',
        type: 'item',
        permission: 'addproduct@isView',
        // icon: IcDashboard,
        margin: '0 0 0 20px',
      },
      {
        id: 'withdraw',
        text: 'Penarikan',
        path: '/finance/withdraw',
        route: '/finance/withdraw',
        type: 'item',
        permission: 'addproduct@isView',
        // icon: IcDashboard,
        margin: '0 0 0 20px',
      },
    ],
  },
  {
    id: 'report',
    text: 'Laporan',
    path: '#',
    route: '/report',
    type: 'collapse',
    permission: 'products@isView',
    icon: AssessmentOutlinedIcon,
    children: [
      {
        id: 'reportorder',
        text: 'Penjualan',
        path: '/report/order',
        route: '/report/order',
        type: 'item',
        permission: 'addproduct@isView',
        // icon: IcDashboard,
        margin: '0 0 0 20px',
      },
      {
        id: 'reporttransaction',
        text: 'Saldo',
        path: '/report/transaction',
        route: '/report/transaction',
        type: 'item',
        permission: 'addproduct@isView',
        // icon: IcDashboard,
        margin: '0 0 0 20px',
      },
    ],
  },
  {
    id: 'users',
    text: 'Users',
    path: '#',
    route: '/users',
    type: 'collapse',
    permission: 'user@isView',
    icon: IcUser,
    children: [
      {
        id: 'userlist',
        text: 'Daftar User',
        path: '/users',
        route: '/users',
        type: 'item',
        permission: 'addUser@isView',
        margin: '0 0 0 20px',
      },
      {
        id: 'assignMerchant',
        text: 'Assign Merchant',
        path: '/users/assign-merchant',
        route: '/users/assign-merchant',
        type: 'item',
        permission: 'assignMerchant@isView',
        margin: '0 0 0 20px',
      },
    ],
  },
  {
    id: 'merchant',
    text: 'Merchant',
    path: '#',
    route: '/merchant',
    type: 'collapse',
    permission: 'merchant@isView',
    icon: IcMerchant,
    children: [
      {
        id: 'merchantlist',
        text: 'Daftar Merchant',
        path: '/merchant',
        route: '/merchant',
        type: 'item',
        permission: 'addMerchant@isView',
        margin: '0 0 0 20px',
      },
    ],
  },
  {
    id: 'chat-history',
    text: 'Chat History',
    path: '/chat-history',
    route: '/chat-history',
    type: 'item',
    permission: 'chat-history@isView',
    icon: QuestionAnswerOutlinedIcon,
  },
  {
    id: 'promo',
    text: 'Promo',
    type: 'item',
    path: '/promos',
    route: '/promos',
    permission: 'addproduct@isView',
    icon: DiscountOutlinedIcon,
  },
  {
    id: 'setting',
    text: 'Pengaturan',
    path: '#',
    route: '/setting',
    type: 'collapse',
    permission: 'products@isView',
    icon: SettingsOutlinedIcon,
    children: [
      {
        id: 'settingprofil',
        text: 'Pengaturan Profil',
        path: '/setting/profile',
        route: '/setting/profile',
        type: 'item',
        permission: 'addproduct@isView',
        margin: '0 0 0 20px',
      },
      {
        id: 'settingbusinessday',
        text: 'Pengaturan Jam Buka Toko',
        type: 'item',
        path: '/setting/business-days',
        route: '/setting/business-days',
        permission: 'businessDay@isView',
        margin: '0 0 0 20px',
      },
      {
        id: 'settingchatbot',
        text: 'Pengaturan Chat Bot',
        path: '/setting/chatbot',
        route: '/setting/chatbot',
        type: 'item',
        permission: 'addproduct@isView',
        margin: '0 0 0 20px',
      },
      // {
      //   id: 'settingaffiliatefee',
      //   text: 'Fee Affiliator',
      //   path: '/setting/affiliate-fee',
      //   type: 'item',
      //   permission: 'addproduct@isView',
      //   margin: '0 0 0 20px',
      // },
      {
        id: 'settingpayout',
        text: 'Payout Setting',
        path: '/setting/payout',
        route: '/setting/payout',
        type: 'item',
        permission: 'addproduct@isView',
        margin: '0 0 0 20px',
      },
      {
        id: 'settingdelivery',
        text: 'Pengaturan Pengiriman',
        path: '/setting/delivery',
        route: '/setting/delivery',
        type: 'item',
        permission: 'addproduct@isView',
        margin: '0 0 0 20px',
      },
    ],
  },
  {
    id: 'custom',
    text: 'Tampilan',
    path: '/Custom',
    route: '/Custom',
    type: 'item',
    permission: 'dashboard@isView',
    icon: IcSlider,
  },
];

export default features;
